<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col  md="4" lg="3">
        <b-form-group label="Naziv pravnog lica *">
          <b-form-input
            type="text"
            v-model="clientData.name"
            name="name">
          </b-form-input>
          <app-validation-description :show="$v.clientData.name.$dirty && $v.clientData.name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="MB *">
          <b-form-input
            type="text"
            v-model="clientData.mb"
            name="mb">
          </b-form-input>
          <app-validation-description :show="$v.clientData.mb.$dirty && $v.clientData.mb.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="JIB / PIB *">
          <b-form-input
            type="text"
            v-model="clientData.jib"
            name="jib">
          </b-form-input>
          <app-validation-description :show="$v.clientData.jib.$dirty && $v.clientData.jib.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Adresa (ulica i broj)">
          <b-form-input
            type="text"
            v-model="clientData.address"
            name="address">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Poštanski broj">
          <b-form-input
            v-model="clientData.zip"
            type="text"
            name="zip">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Mjesto">
          <b-form-input
            type="text"
            v-model="clientData.place"
            name="place">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Država">
          <b-form-input
            type="text"
            v-model="clientData.country"
            name="country">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Telefon">
          <b-form-input
            type="text"
            v-model="clientData.phone"
            name="phone">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Faks">
          <b-form-input
            v-model="clientData.faks"
            type="text"
            name="faks">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Email *">
          <b-form-input
            v-model="clientData.email"
            type="text"
            name="email">
          </b-form-input>
          <app-validation-description :show="$v.clientData.email.$dirty && $v.clientData.email.$invalid">
            <template v-if="!$v.clientData.email.email">
              Unesite ispravan email
            </template>
            <template v-else>
              {{$t('FIELD_MANDATORY')}}
            </template>
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Email 2">
          <b-form-input
            v-model="clientData.email2"
            type="text"
            name="email2">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Broj žiro računa">
          <b-form-input
            type="text"
            v-model="clientData.account_number"
            name="account_number">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Naziv banke">
          <b-form-input
            v-model="clientData.name_of_bank"
            type="text"
            name="name_of_bank">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Broj žiro računa 2">
          <b-form-input
            v-model="clientData.account_number2"
            type="text"
            name="account_number2">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Naziv banke 2">
          <b-form-input
            type="text"
            v-model="clientData.name_of_bank2"
            name="name_of_bank2">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h5>Za ovlašteno lice</h5>
        <hr/>
      </b-col>
    </b-row>
    <b-row>
      <b-col  md="4" lg="3">
        <b-form-group label="Ime i prezime">
          <b-form-input
            type="text"
            v-model="clientData.authorized_person_name"
            name="authorized_person_name">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="JMBG">
          <b-form-input
            type="text"
            v-model="clientData.authorized_person_jmbg"
            name="authorized_person_jmbg">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Adresa (ulica i broj)">
          <b-form-input
            type="text"
            v-model="clientData.authorized_person_address"
            name="authorized_person_address">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Poštanski broj">
          <b-form-input
            type="text"
            v-model="clientData.authorized_person_zip"
            name="authorized_person_zip">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Mjesto">
          <b-form-input
            type="text"
            v-model="clientData.authorized_person_place"
            name="authorized_person_place">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="4" lg="3">
        <b-form-group label="Država">
          <b-form-input
            type="text"
            v-model="clientData.authorized_person_country"
            name="authorized_person_country">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <submit :loading="loading"></submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import Submit from "@/components/app/AppSubmit";
import {required, email} from "vuelidate/lib/validators";
import AppValidationDescription from "@/components/app/form/AppValidationDescription";
import { clientMixin } from "@/mixins/client/clientMixin";
import {getErrorMessage} from "@/mixins/error/getErrorMessage";

export default {
  name: "ClientLegalEntityForm",
  mixins: [clientMixin, getErrorMessage],
  data() {
    return {
      clientData: {
        name: null,
        mb: null,
        jib: null,
        email: null,
        email2: null,
        address: null,
        zip: null,
        place: null,
        country: null,
        phone: null,
        faks: null,
        account_number: null,
        account_number_2: null,
        name_of_bank: null,
        name_of_bank2: null,
        authorized_person_name: null,
        authorized_person_jmbg: null,
        authorized_person_address: null,
        authorized_person_zip: null,
        authorized_person_place: null,
        authorized_person_country: null,
        type: 1
      }
    };
  },
  validations:{
    clientData:{
      name: { required },
      mb: { required },
      jib: { required },
      email: { required, email },
    }
  },
  components: {
    Submit,
    AppValidationDescription
  },
}
</script>

<style scoped>

</style>
